
import { useState, useEffect } from "react";
import {
  getHospitalDetail,
} from "api/hospital";
import { useParams } from "react-router-dom";
import styles from "../index.less";
import HospitalNav from "./Nav";

import HospitalHead from "../floor/hospitalHead";
import Head from "./head";
import BreadHead from "./breadHead";
import { getPageId, hospitalNav } from "utils/hospital";
import { ErrorComp } from "components/error";
import PcseoRecommondCard from "@jdh-cargo/block-pcseo-recommond-card";
import { getNavigationBarDto } from "api/tab-bar";

const Template = ({ children, breadTitle }: any) => {

  const params = useParams<Record<any, any>>();
  const [pageId, setPageId] = useState<any>();
  const [hospitalInfo, setHospitalInfo] = useState<any>();
  const [loading, setLoading] = useState(true);

  const [navList, setNavList] = useState<any[]>();
  const getNavigationBarDtoFunc = (baseNav?: any[]) => {
    const baseNavList = baseNav;
    // 后端控制tab的展示和链接
    getNavigationBarDto({ currentUrl: window.location.href }).then(
      (res: any) => {
        const realList = res?.map((item: any) => {
          const url = item.url;
          let cItem;
          try {
            const Url = new URL(url);
            const path = Url.pathname;
            cItem = baseNavList?.find((iitem) => iitem.url === path);
          } catch (e) {
            console.log(e);
          }
          return {
            ...cItem,
            ...item,
          };
        });
        setNavList(realList?.length ? realList : undefined);
        // setNavList(realList?.length ? realList : baseNavList);
      }
    ).catch(e=>{
      console.log(e)
      // setNavList(baseNavList);
    })
  };
  useEffect(()=>{
    if(pageId){
      const baseNav = hospitalNav(`${pageId}`);
      // @ts-ignore
      // setNavList(baseNav);
      getNavigationBarDtoFunc(baseNav);
    }
  },[pageId]);
  
  useEffect(() => {
    if (params.id) {
      setPageId(getPageId(params.id).pageId);
      getPageFloorElementFun(getPageId(params.id).pageId);
    }
  }, []);
  // 获取医院基本信息
  const getPageFloorElementFun = (hospitalId: any) => {
    getHospitalDetail({ hospitalId }).then((res: any) => {
      console.log(res);
      setHospitalInfo(res);
    }).finally(() => setLoading(false));
  };
  return (
    <div className={styles.hospital}>
      {/* // 头部 */}
      {/* <Head /> */}
      {
        !loading && !hospitalInfo && <ErrorComp />
      }
      {
        !loading && hospitalInfo && 
        <div className={styles.centerContainer}>
          {/* 面包屑 */}
          <BreadHead initData={hospitalInfo} pageId={pageId} title={breadTitle} />
          {/* 医院本信息头部 */}
          <HospitalHead data={hospitalInfo} />
          {/* 导航 */}
          <HospitalNav pageId={pageId} navList={navList} />
          {/* 内容 */}
          <div className={styles.content}>
            {/* 左 */}
            <div className={styles.left}>
              {/* 左下部分数据 */}
              {children(hospitalInfo)}
            </div>
            {/* 右 */}
            <div className={styles.right}>
              {/* 快速向专家提问 */}
              {hospitalInfo && <PcseoRecommondCard />}
            </div>
          </div>
        </div>
      }
      {/* // 底部线 */}
      <div className={styles.footerLine}>
        <p></p>
      </div>
      <div className={styles.footerData} id="m_common_bottom" />
    </div>
  );
};
export default Template;
